import { RatingServiceMock } from "@/orders/services/rating/rating.types";

export const mockRatingService = (): RatingServiceMock => ({
  sendRating: jest.fn(),
});
